<script lang="ts" setup>
import { onMounted, ref } from 'vue'

import CardWrapper from '@/components/wrappers/CardWrapper.vue'
import ListWrapper from '@/components/wrappers/ListWrapper.vue'
import SectionWrapper from '@/components/wrappers/SectionWrapper.vue'
import { getLanguage } from '@/helpers/language-helper'
import {
  fetchAdvantagesStore,
  useAdvantagesDataDescription,
  useAdvantagesDataHeading,
  useAdvantagesDataItems
} from '@/services/HomePage/advantagesService'

fetchAdvantagesStore()

const heading = useAdvantagesDataHeading()
const description = useAdvantagesDataDescription()
const items = useAdvantagesDataItems()

const lang = ref<string | null>('en')

onMounted(() => {
  lang.value = getLanguage()
})
</script>

<template>
  <SectionWrapper class="relative z-20 pt-20 pb-20 bg-custom-radial-upper lg:pt-40">
    <template v-slot:header>
      <h2
        class="mb-2.5 text-2xl md:text-4.5xl font-bold text-neutral-100 max-w-1200 mx-2.5 lg:mx-auto leading-normal"
      >
        {{ heading }}
      </h2>
    </template>
    <template v-slot:subheader>
      <p
        class="text-lg md:text-xl font-normal text-gray-350 max-w-1200 mx-2.5 lg:mx-auto leading-normal mb-0"
      >
        {{ description }}
      </p>
    </template>
    <template v-slot:content>
      <ListWrapper
        :itemsList="items"
        class="max-w-1200 mx-auto grid grid-rows-3 gap-y-10 md:gap-y-9.3 lg:grid-cols-3 lg:grid-rows-1 pt-10 md:pt-20"
      >
        <template v-slot="{ item }">
          <CardWrapper
            :cardDetails="item"
            class="col-span-1 px-0 py-10 lg:px-0 lg:pt-13.5 lg:pb-18.5 rounded-2.5 border-3 mx-2.5 md:mx-0"
            name="item"
          >
            <template v-slot:card-image>
              <img
                :alt="item?.description"
                :src="item.image"
                class="mx-auto mb-13.5"
                loading="lazy"
              />
            </template>
            <template v-slot:card-description>
              <p
                class="def:text-base def:font-normal def:text-gray-350 def:pt-5 def:px-9 def:leading-normal def:tracking-negative-tightest"
                :class="lang === 'ko' ? 'break-keep' : ''"
              >
                {{ item?.description }}
              </p>
            </template>
          </CardWrapper>
        </template>
      </ListWrapper>
    </template>
  </SectionWrapper>
</template>
